import Select from "react-select";
import { MultiSelectProps, SelectOption } from "./type";

const MultiSelect = ({
  options,
  value,
  onChange,
  placeholder = "Select...",
  isDisabled = false,
}: MultiSelectProps) => {
  return (
    <Select
      isMulti
      options={options}
      value={value}
      onChange={(selected) => onChange(selected as SelectOption[])}
      placeholder={placeholder}
      isDisabled={isDisabled}
      closeMenuOnSelect={false}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: "40px",
          backgroundColor: "#F5F7FA",
          border: "none",
          boxShadow: "none",
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "0 8px",
        }),
      }}
    />
  );
};

export default MultiSelect;
